import { useSyncExternalStore } from 'react';
import { useMyCompanies } from './companies';
import { activeCompanyStore } from './active-company-store';

/**
 * The active company for this tab: the stored one when the user belongs to
 * it, otherwise their first company, otherwise undefined. Re-renders on every
 * switch, because it subscribes to the store.
 */
export function useActiveCompanyId(): number | undefined {
  const { data: companies } = useMyCompanies();
  const stored = useSyncExternalStore(
    activeCompanyStore.subscribe,
    activeCompanyStore.get,
    () => undefined, // server render: no tab, no company
  );

  if (!companies || companies.length === 0) return undefined;
  if (stored !== undefined && companies.some((c) => c.id === stored)) return stored;

  // The stored company is missing or no longer ours. Record the fallback now,
  // so the X-Company-Id header matches before any company-scoped request runs.
  const fallback = companies[0].id;
  activeCompanyStore.adopt(fallback);
  return fallback;
}

export function setActiveCompanyId(id: number) {
  activeCompanyStore.set(id);
}
